<header>
  <mat-toolbar>
    <div *ngIf="auth.authed">
      <button mat-button (click)="sideBarToggle.emit(true)">
        <mat-icon mat-list-icon>menu</mat-icon>
      </button>
    </div>
    <span class="logo"></span>
    <a class="home" routerLink="/admin/"><span>SSO-Admin</span></a>
    <div class="user-menu" *ngIf="auth.authed">
      <button mat-button [matMenuTriggerFor]="userMenu">
        {{auth.user.name}}
        <mat-icon mat-list-icon>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button (click)="logout()" mat-menu-item>Abmelden
          <mat-icon mat-list-icon>exit_to_app</mat-icon>
        </button>
      </mat-menu>
    </div>
  </mat-toolbar>
</header>
